import { render, staticRenderFns } from "./IQSidePanelUserMessage.vue?vue&type=template&id=1dc798ee&scoped=true"
import script from "./IQSidePanelUserMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./IQSidePanelUserMessage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IQSidePanelUserMessage.vue?vue&type=style&index=0&id=1dc798ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc798ee",
  null
  
)

export default component.exports